import React from "react";
import DisplayCardList from "../../componenets/DisplayCardList";
import { featuresData } from "../../data";

const APItasks = () => {
  return <DisplayCardList data={featuresData} />;
};

export default APItasks;
